import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import pickBy from 'lodash/pickBy';

import { rescheduleClassesAppliedFiltersSelector } from '@classCreation/selectors/rescheduleClassesFilter';
import applyFiltersOnRescheduleClasses from '@classCreation/utils/applyFiltersOnRescheduleClasses';
import getUpcomingSbatGroups from '@classCreation/utils/getUpcomingSbatGroups';
import isValidSbatGroupFilter from '@classCreation/utils/isValidSbatGroupFilter';

export default function useFilteredRescheduleClasses(sbatGroups) {
  const appliedFilters = useSelector(rescheduleClassesAppliedFiltersSelector);

  const upcomingSbatGroups = useMemo(
    () => getUpcomingSbatGroups(sbatGroups),
    [sbatGroups]
  );

  const filteredSbatGroups = useMemo(() => {
    const validFilters = pickBy(appliedFilters, isValidSbatGroupFilter);

    if (Object.keys(validFilters).length > 0) {
      return upcomingSbatGroups.map((sbatGroup) => {
        const isDisabled = !applyFiltersOnRescheduleClasses({
          sbatGroup,
          filters: validFilters,
        });

        return isDisabled
          ? { ...sbatGroup, locked: true }
          : { ...sbatGroup, locked: false };
      });
    } else {
      return upcomingSbatGroups;
    }
  }, [appliedFilters, upcomingSbatGroups]);

  return filteredSbatGroups;
}
